import {ChangeDetectionStrategy, Component} from '@angular/core'

@Component({
  selector: 'cft-sorting-bar',
  template: '<div *cftI18n="let t" class="mr-xs">{{t("sortingLabel")}}</div><ng-content></ng-content>',
  styleUrls: ['./sorting-bar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SortingBarComponent {}
